
import { ActivoFijoModel } from './../../../../models/activoFijo.model';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChange, SimpleChanges } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RegistroIngSalActivoFijo } from 'src/app/shared/models/registroIngSalActivoFijo.model';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ingSalActivoFijo } from 'src/app/models/IngSalActivoFijo.model';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { element } from '@angular/core/src/render3';
import { DominiosService } from 'src/app/shared/services/dominios.service';


@Component({
  selector: 'app-activos-recientes',
  templateUrl: './activos-recientes.component.html',
  styleUrls: ['./activos-recientes.component.scss']
})
export class ActivosRecientesComponent implements OnInit, OnChanges {


  @Input() cardOptions: any;
  @Input() listaActivos: ActivoFijoModel[] = [];
  @Input() public ListaActivosPorFuncionario: RegistroIngSalActivoFijo;
  @Input() activosFijosFuncionarioPropioMen: ingSalActivoFijo[];
  @Input() pantallaOrigen: any;
  @Output() ActivoSeleccionado = new EventEmitter();
  @Output() filtroDeBusqueda = new EventEmitter();
  @Output() tipoActivo = new EventEmitter();
  @Input() listaSedes;
  @Input() datosFuncionario;
  @Input() arregloLongitud: number;
  @Output() sedeSeleccion = new EventEmitter(); // sede que se envìa al apadre opara registros
  ActivoSeleccion: any;
  modalOptionsIngresar: ConfirmationModalOptions;
  modalOptionsRetirar: ConfirmationModalOptions;
  banderaTarjeta: boolean;
  sede: any;
  public listaActivosVisual: any;
  private listaActivosPropiosFuncionario: any;
  private listaActivosMENFuncionario: any;
  public sedeSeleccionada: boolean;
  public activoPropio: string;
  public activoMen: string;
  public asignado: string;
  public autorizado: string;
  public banderaMen: boolean;

  constructor(
    private alertService: AlertService,
    private spinner: NgxSpinnerService) {

    this.sedeSeleccionada = null;
    this.listaActivosPropiosFuncionario = [];
    this.listaActivosMENFuncionario = [];
    this.ListaActivosPorFuncionario = new RegistroIngSalActivoFijo('', '', '', '', '', '', '', '');
    this.listaActivos = [];
    this.sede = null;
    this.listaActivosVisual = [];
    this.activosFijosFuncionarioPropioMen = [];
    this.listaSedes = [];
    this.cardOptions = new Object();
    this.cardOptions.PlaceHolder = 'Código Placa Inventario del Ministerio';
    this.cardOptions.FiltroBusqueda = '';
    this.cardOptions.Pantalla = '';
    this.modalOptionsIngresar =
      new ConfirmationModalOptions('Confirmación', ConstantesService.CONFIRMACION_INGRESO_ACTIVO,
        'SI', 'NO', 'fas fa-level-up-alt', true, false, 'Ingresar elemento', null, 'btn-secondary pull-left');
    this.modalOptionsRetirar =
      new ConfirmationModalOptions('Confirmación', ConstantesService.CONFIRMACION_RETIRO_ACTIVO,
        'SI', 'NO', 'fas fa-level-down-alt', true, false, 'Retirar elemento', null, 'btn-secondary pull-right');
    this.banderaTarjeta = false;
    this.activoPropio = DominiosService.ACTIVO_PROPIO;
    this.activoMen = DominiosService.ACTIVO_MEN;
    this.asignado = DominiosService.ACTIVO_FIJO_ASIGNADO;
    this.autorizado = DominiosService.ACTIVO_FIJO_AUTORIZADO;
    this.banderaMen = false;
  }
  ngOnInit() {
    this.sede = sessionStorage.getItem(ConstantesService.SEDE_DEFECTO_SESSSION);
    if (this.listaActivosVisual && this.listaActivosVisual.length >= 1) {
      this.clasificarActivos();
      setTimeout(() => {
        this.verActivosMEN(false);
      }, 1000);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.ListaActivosPorFuncionario) {
      this.listaActivos = changes.ListaActivosPorFuncionario.currentValue;
      this.limpiarBotones();
    }
    if (changes.listaActivos) {
      this.listaActivos = changes.listaActivos.currentValue;
    }
    if (changes.datosFuncionario) {

    }
    if (changes.pantallaOrigen) {
      if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA) {
        // this.modalOptionsRetirar.disabled = true;
      } else if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA) {
        this.modalOptionsIngresar.disabled = true;
      }
    }

    if (changes.activosFijosFuncionarioPropioMen) {
      this.activosFijosFuncionarioPropioMen = changes.activosFijosFuncionarioPropioMen.currentValue;
    }


    this.clasificarActivos();
  }


  // 13/06/2019
  // clasifica los activos del funcionario en propios o men
  private clasificarActivos() {
    this.listaActivosMENFuncionario = [];
    this.listaActivosPropiosFuncionario = [];
    if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_FUNCIONARIO) {

      setTimeout(() => {
        if (!this.banderaTarjeta) {
          document.getElementById('btnActivosPropios').classList.remove('selected');
          document.getElementById('btnActivosMEN').classList.add('selected');
        }
      }, 1000);

      this.listaActivosVisual = this.activosFijosFuncionarioPropioMen;
    } else if (this.listaActivos && this.listaActivos.length > 0) {
      this.listaActivosVisual = this.listaActivos;
    }
    // if (this.listaActivos) {
    //   if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_FUNCIONARIO && this.listaActivos.length > 0) {
    //     this.listaActivos.forEach(activo => {
    //       if (activo.perteneceA === ConstantesService.ACTIVO_MEN) {
    //         this.listaActivosMENFuncionario.push(activo);
    //       } else {
    //         this.listaActivosPropiosFuncionario.push(activo);
    //       }
    //     });
    //     document.getElementById('btnActivosMEN').classList.add('selected');
    //     document.getElementById('btnActivosPropios').classList.remove('selected');
    //     this.listaActivosVisual = this.listaActivosMENFuncionario;
    //   } else if (this.listaActivos.length > 0) {
    //     this.listaActivosVisual = this.listaActivos;
    //   }
    // }
  }


  // 11/06/2019
  // emite el filtro de bùsqueda de la tarjeta de activosLILI
  buscarActivoFijo() {

    if (this.cardOptions.FiltroBusqueda === undefined || this.cardOptions.FiltroBusqueda === '') {
      if (this.banderaMen) {
        this.cathException(ConstantesService.FILTRO_ACTIVOS_RECIENTES_VACIO_MEN);
      } else {
        this.cathException(ConstantesService.FILTRO_ACTIVOS_RECIENTES_VACIO_PROPIO);
      }
    } else {

      if (this.sede && this.sede != null) {
        this.filtroDeBusqueda.emit(this.cardOptions.FiltroBusqueda);
        this.sedeSeleccion.emit(this.sede)
        this.listaActivosMENFuncionario = [];
        this.listaActivosPropiosFuncionario = [];
        // this.listaActivosVisual = [];
      } else {
        this.alertService.generateAlertError('El campo sede es obligatorio', '');
      }
    }
  }



  /**
   * 
   *  11 /06/2019
   *  metodo para seleccionar un unico elemnto de la lista
   * @param evento 
   * @param activo 
   * @param key 
   * @author fromero
   */
  seleccionarActivo(evento, activo: ActivoFijoModel, key?) {
    var keycode = evento.which;
    if (evento.currentTarget.checked && !key) {
      this.listaActivosVisual.forEach(element => {
        element.seleccionado = element.idActivo === activo.idActivo ? true : false;
      });
    } else if (key && keycode != 9) {
      this.listaActivosVisual.forEach(element => {
        if (!element.seleccionado && element.idActivo === activo.idActivo) {
          element.seleccionado = true;
        } else if (element.seleccionado && element.idActivo === activo.idActivo) {
          element.seleccionado = false;
        } else if (element.seleccionado && element.idActivo !== activo.idActivo) {
          element.seleccionado = false;
        }
      });
    } else {
      if (!key || (key && keycode != 9)) {
        this.limpiarBotones();
      }
      return;
    }
    if (activo.estado == DominiosService.ESTADO_ACTIVO_FIJO_VALOR_INGRESADO ||
      activo.estado == ConstantesService.ESTADO_ACTIVO_FIJO_VALOR_NO_REGISTRA_SALIDA) {
      if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_ENTRADA) {
        this.modalOptionsRetirar.disabled = true;
      } else {
        this.modalOptionsRetirar.disabled = false;
      }
      this.modalOptionsIngresar.disabled = true;
    } else {
      if (this.pantallaOrigen === ConstantesService.PANTALLA_INGRESO_SALIDA_VISITANTE_SALIDA) {
        this.modalOptionsIngresar.disabled = true;
      } else {
        this.modalOptionsIngresar.disabled = false;
      }
      this.modalOptionsRetirar.disabled = true;
    }
    if (this.datosFuncionario) {
      if (activo.numeroIdFuncionario !== this.datosFuncionario.numeroIdFuncionario) {
        this.modalOptionsRetirar.message = ConstantesService.CONFIRMACION_RETIRO_ACTIVO_NO_PROPIO;
      }
    }

    var contadorLimpiar = 0;
    this.listaActivosVisual.forEach(element => {
      if (element.seleccionado) {
        contadorLimpiar++;
      }
    });
    if (contadorLimpiar == 0) {
      this.limpiarBotones();
    }
  }

  /**
   * 
   */
  limpiarBotones() {
    this.modalOptionsIngresar.disabled = true;
    this.modalOptionsRetirar.disabled = true;
  }

  /**
   * Metodo de envio de activo Seleccionado
   * 11/06/2019
   * @param accion 
   */
  enviarListaSeleccionados(accion) {

    let activoSeleccion: ActivoFijoModel = null;

    this.listaActivosVisual.forEach(element => {
      if (element.seleccionado) {
        activoSeleccion = element;
      }
    });

    if (this.sede && this.sede != null) {
      activoSeleccion.sede = this.sede;
      this.ActivoSeleccionado.emit({ Activo: activoSeleccion, Accion: accion });
      this.modalOptionsIngresar.disabled = true;
      this.modalOptionsRetirar.disabled = true;
    } else {
      this.sede = null;
      this.alertService.generateAlertError('El campo sede es obligatorio', '');
    }


  }


  // 11/05/2019
  // método para obtener la respuesta de la confirmación del evento
  getConfirmationModalResponse(event, accion) {
    if (event[0]) {
      this.enviarListaSeleccionados(accion);
      this.modalOptionsRetirar.message = ConstantesService.CONFIRMACION_RETIRO_ACTIVO;
    } else {
      this.modalOptionsRetirar.message = ConstantesService.CONFIRMACION_RETIRO_ACTIVO;
    }
  }


  // 13/06/2019
  // activa el panel de activos propios para funcionario
  verActivosPropios(banderaTarjeta: boolean) {
    this.banderaMen = false;
    const activoMEN = document.getElementById('btnActivosMEN');
    const activoPropio = document.getElementById('btnActivosPropios');
    if (activoMEN) { activoMEN.classList.remove('selected'); }
    if (activoPropio) { activoPropio.classList.add('selected'); }
    this.listaActivosVisual = this.activosFijosFuncionarioPropioMen;
    this.banderaTarjeta = banderaTarjeta;
    this.tipoActivo.emit(DominiosService.ACTIVO_PROPIO);
    this.limpiarBotones();
  }

  // 13/06/2019
  // activa el panel de activos MEN para funcionario
  verActivosMEN(banderaTarjeta: boolean) {
    this.banderaMen = true;
    const activoPropio = document.getElementById('btnActivosPropios');
    const activoMEN = document.getElementById('btnActivosMEN');
    if (activoPropio) { activoPropio.classList.remove('selected'); }
    if (activoMEN) { activoMEN.classList.add('selected'); }
    this.listaActivosVisual = this.activosFijosFuncionarioPropioMen;
    this.banderaTarjeta = banderaTarjeta;
    this.tipoActivo.emit(DominiosService.ACTIVO_MEN);
    this.limpiarBotones();
  }

  // CAPTURA las ecpeciones y las lanza en una alerta
  cathException(error) {
    this.alertService.generateAlertError(error, 'Error');
    this.spinner.hide();
  }

  public muestrValidacion() {
    return this.listaActivosVisual && this.listaActivosVisual.length > 0;
  }
}
